/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ProposalRequestBanner from './ProposalRequestBanner';
const mockQueryClient = new QueryClient({
    defaultOptions: { queries: { retry: false }, mutations: { retry: false } }
});
const meta = {
    title: 'Features/Proposals/ProposalShow/ProposalRequestBanner',
    component: ProposalRequestBanner,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement(QueryClientProvider, { client: mockQueryClient },
            React.createElement("div", { style: { maxWidth: '760px', margin: '40px auto' } },
                React.createElement(Story, null))))
    ]
};
export default meta;
export const Convertible = {
    args: {
        proposalId: '1042',
        canConvert: true
    }
};
export const ReadOnly = {
    args: {
        proposalId: '1042',
        canConvert: false
    }
};
